<template>
 <div>
      <HeroHeader></HeroHeader>
      <div id="text-scroll" class="text-scroll animated animated-delay-3">
            <div class="text-scroll-inner">   
               <sendyInlineKickstarter></sendyInlineKickstarter>
            </div>
        </div>
   </div> 
</template>

<script>
import SendyModal from "@/views/Home/SendyModal.vue";
import HeroHeader from "@/components/HeroHeader.vue";
import sendyInlineKickstarter from "@/components/sendyInlineKickstarter.vue";
export default {
  name: "Giveaway",
  data() {
    return {
      msg: ""
    };
  },
  components: {
    HeroHeader,
    sendyInlineKickstarter
  }
};
</script>



<style>
/* .tooltip{
  opacity: 1 !important;
} */
.iframeWrapper div#mySendyModal {
    display: flex !important;
   position: inherit !important;
   padding: 0 !important;
    box-shadow: 1px 5px 12px 0 rgba(0,0,0,.75);
}
.iframeWrapper div#mySendyModal .sendyModal {
    width: 100%;
    max-width: 45em;
}
.iframeWrapper  a.closebtn {
    display: none;
}
.iframeWrapper h2.follow-title:after {
    content: "Giveaway Ended";
    visibility: visible;
    display: block;
    font-size: 36px;
    line-height: 1;
}
.iframeWrapper h2.follow-title {
    visibility: hidden;
    font-size: 1px;
}
.iframeWrapper h4.follow-subtitle {
    visibility: hidden;
    font-size: 1px;
}
.iframeWrapper  h4.follow-subtitle:after {
    content: "Subscribe to get notified of future giveaways!";
    visibility: visible;
    display: block;
        font-size: 16px;
}
/* h2.giveaway-title:after {
        content: "Subscibe to get notified of future givaways";
    display: block;
    font-size: 20px;
    text-transform: capitalize;
} */
.socialMan section#heroheader {
    position: fixed;
}
.desktop .text-scroll,.mobile .text-scroll {
    top: 0;   
    bottom: 0;
}
@media only screen and (min-width: 901px) and (max-width: 1439px) {
   
    .text-scroll-inner.giveaway-flex {
        position: relative !important;
        bottom: 20px;
    }
}
@media only screen and (min-width: 1200px) {
    .mobile {
        display: none;
    }
}
.giveaway-col.giveaway-col1 {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: flex-end;
}

.giveaway-col video {
position: absolute;
    display: block;
    margin-top: -18%!important;
    width: 70%;
        background: url(/static/assets/images/Dwerve-Alpha.jpg);
}
.giveaway-col img {
    object-fit: contain;
}
.giveaway-col {
    width: 33%;
        max-width: 514px;
}
@media only screen and (max-width: 1441px) {


.fixed-title img.game-title.dwerveTitle {
    max-width: 700px;
}
h2.giveaway-title {
position: absolute !important;
    top: 211px;
    font-size: 55px !important;
    
    margin-top: 20px !important;
}
}
@media only screen and (max-width: 1331px) {
  .fixed-title img.game-title.dwerveTitle {
    width: 100%;
}
}
@media only screen and (max-width: 550px) {
  .fixed-title img.game-title.dwerveTitle {
  max-width: 338px !important;
}
.fixed-title h2.giveaway-title {
   top: 124px !important;
    font-size: 49px !important;
}
}
@media only screen and (max-width: 100px) {
  .text-scroll-inner.giveaway-flex .giveaway-col video {
      margin-top: 32% !important;
  }
  
}
@media only screen and (max-width: 1200px) {
  iframe {
   min-height: auto;
}
      .giveaway-col video {
        width: 71%;
        min-width: 5%;
            max-width: 359px;
        position: absolute;
      }
      h2.giveaway-title {
        top: 145px !important;
        position: absolute !important;
    }
    .giveaway-col {
        width: 100% !important;
    }
    iframe#sm_iframe {
        width: 100% !important;
    }
    .text-scroll-inner.giveaway-flex {
        position: relative;
        bottom:
         20px;
         background: url(/static/assets/images/Dwerve-Brick-Texture.png);
         align-items: center;
    flex-direction: column;
    }
    .giveaway-col.giveaway-col1 {
      margin-top: 6em;
    }
  
    .fixed-title {
        position: absolute;
        top: 0;
        z-index: 1;
    }
    .fixed-title img.game-title.dwerveTitle {
          max-width: 445px;
    }
}
.giveaway-flex img.giveaway-col {
    width: 33%;
    max-width: 489px;
    object-fit: cover;
    position: relative;
}
h2.giveaway-title {
    font-family: Grandmaster;
  font-size: 67px;
    width: 100%;
    filter: drop-shadow(2px 5px 13px #33262c);
    margin-top: -116px;
    position: absolute;
    color: #f1d104;
    text-shadow: -2.4px -2.4px 0 #282e35, -2.4px -1.4px 0 #282e35, -2.4px -0.4px 0 #282e35, -2.4px 0.6px 0 #282e35, -2.4px 1.6px 0 #1d1a44, -2.4px 2.6px 0 #282e35, -1.4px -2.4px 0 #282e35, -1.4px -1.4px 0 #282e35, -1.4px -0.4px 0 #282e35, -1.4px 0.6px 0 #282e35, -1.4px 1.6px 0 #282e35, -1.4px 2.6px 0 #282e35, -0.4px -2.4px 0 #282e35, -0.4px -1.4px 0 #282e35, -0.4px -0.4px 0 #282e35, -0.4px 0.6px 0 #282e35, -0.4px 1.6px 0 #282e35, -0.4px 2.6px 0 #282e35, 0.6px -2.4px 0 #282e35, 0.6px -1.4px 0 #282e35, 0.6px -0.4px 0 #282e35, 0.6px 0.6px 0 #282e35, 0.6px 1.6px 0 #282e35, 0.6px 2.6px 0 #282e35, 1.6px -2.4px 0 #282e35, 1.6px -1.4px 0 #282e35, 1.6px -0.4px 0 #282e35, 1.6px 0.6px 0 #282e35, 1.6px 1.6px 0 #282e35, 1.6px 2.6px 0 #282e35, 2.6px -2.4px 0 #282e35, 2.6px -1.4px 0 #282e35, 2.6px -0.4px 0 #282e35, 2.6px 0.6px 0 #282e35, 2.6px 1.6px 0 #282e35, 2.6px 2.6px 0 #282e35;
}
.game-title.dwerveTitle {
    max-width: 801px;
}
.giveaway-flex {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
}
.fixed-title{
  width: 100%;

    text-align: center;
}

.popover {
  display: block !important;
    color: black;
    width: 100%;
    max-width: 585px;
    padding: 10px;
    height: 105px;
    z-index: 1100;
}
@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.vue-popover-theme.open {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
}
.tooltip-inner a:HOVER {
    color: #01d3f9;
}
.tooltip-inner a{
    color: #01d3f9;
    transition: none;
}
.open a.tooltip-target {
  content: '\F0D7' !important;
}

.tooltip-inner {
    max-width: 100%;
    padding: 3px 8px;
    color: #fff;
    text-align: center;
    background-color: #1073a6;
    border-radius: 4px;
}
.tooltip-inner p {
    font-size: 14px;
    font-family: "Open Sans", sans-serif;
    margin-bottom: 0;
    text-shadow: 1px 1px 2px #081a4269;
    padding: 10px;
    text-align: left;
}
.open a.tooltip-target.b3.active:before {
    content: '\F0D7';
}
.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: .5s ease-in-out;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: fade .5s ease-in-out;
}
@media only screen and (max-width: 580px){
  .popover{
    max-width: 276px;
  }
}
span.helpTooltip {
    position: absolute;
    bottom: 0px;

}
span.helpTooltip a {
    color: #07618c;
    font-size: 25px;
    padding: 8px;
    margin-bottom: 10px;
    display: block;
    filter: none;
    animation: changeColor 1s infinite;
    text-shadow: none;
}
.iframeWrapper{
      display: flex;
    flex-direction: column;
        margin-top: 22px;
    width: 33%;
    position: relative;
        max-width: 474px;
    align-items: center;
}
@keyframes changeColor {
  0% {
    color: #07618c;
  }
  100% {
    color: #FF4136;
  }
}

@media only screen and (max-width: 1199px) {
.iframeWrapper {
    width: 100%;
    max-width: 478px;
    text-align: center;
}
}
.swal2-icon.swal2-info.swal2-icon-show .swal2-icon-content {
    display: none;
}
.swal2-container.swal2-center {
    z-index: 999999;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/Kickstarter.vue